<template>
  <b-modal :active="active" :canCancel="false" has-modal-card>
    <form class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-t="'title'" />
      </header>

      <section class="modal-card-body">
        <div v-if="!isLoading">
          <products-form :product.sync="product" :errors="errors" />
        </div>
        <loading-content v-else />
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="close()">
          <b-icon icon="times" />
          <span v-t="'buttons.cancel'" />
        </button>

        <button
          type="submit"
          class="button is-danger"
          @click.prevent="save()">
          <b-icon icon="save" />
          <span v-t="'buttons.save'" />
        </button>
      </footer>
    </form>
  </b-modal>
</template>

<script>
import API from '@/api'
import ProductsForm from './ProductsForm'
import LoadingContent from './LoadingContent'

export default {
  name: 'ProductsModal',
  props: { active: Boolean },
  components: {
    ProductsForm,
    LoadingContent
  },
  data () {
    return {
      isLoading: true,
      errors: {},
      product: {
        name: '',
        logo: null
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      // Busca pelas informações do usuário
      this.isLoading = true
      API.products.find(this.productId, product => {
        this.product = {
          name: product.name,
          logo: { name: this.logoFilename(product.name) }
        }

        this.$emit('update:product', this.product)
        this.isLoading = false
      })
    },
    save () {
      let formData = new FormData()

      formData.append('name', this.product.name)

      if (this.product.logo !== null && this.product.logo instanceof File) {
        formData.append('logo', this.product.logo)
      }

      API.products.update(this.productId, formData, this.saveCallback, this.errorCallback)
    },
    close () {
      this.product = {}
      this.$router.push({ name: 'products' })
    },
    saveCallback () {
      this.$snotify.success(this.$t('alerts.success'), this.$t('alert.title.success'))
      this.close()
    },
    errorCallback (err) {
      this.$snotify.error(this.$t('alerts.error'), this.$t('alert.title.error'))
      if (err.response) {
        this.errors = err.response.data.errors
      }
    },
    logoFilename (name) {
      return name.toLowerCase().replace(/\s/, '_') + '.jpg'
    }
  },
  computed: {
    productId () {
      return this.$route.params.product
    }
  }
}
</script>

<i18n src="@/lang/locales.json"></i18n>
<i18n>
{
  "en-US": {
    "title": "Edit Product",
    "buttons": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "alerts": {
      "success": "Product updated successfully!",
      "error": "An error occurred when updating the product!"
    }
  },
  "pt-BR": {
    "title": "Editar Produto",
    "buttons": {
      "cancel": "Cancelar",
      "save": "Salvar"
    },
    "alerts": {
      "success": "Produto atualizado com sucesso!",
      "error": "Erro ao atualizar o produto!"
    }
  }
}
</i18n>
